//#region INTERFACE IStockEditThresholds

export interface IStockItemEditThresholds {
  sellPriIncl1: {
    pct: number;
    negPct: number;
  };
}

//#endregion